import { get } from '@helpcenter/ajax';
import { Observable } from '@helpcenter/epics-rxjs';
import * as qs from 'query-string';
import { trackError } from '@atlassian/help-center-common-util/analytics';
import { contextPath } from '@atlassian/help-center-common-util/history';

interface LabelQuery {
    query: string;
    portalId: number;
    customFieldId: string | undefined;
    requestTypeId: number;
}

type LabelSearchResponse = string[];

interface LabelSearchRawResponse {
    token: string;
    suggestions: {
        label: string;
    }[];
}

export const searchLabel = (labelQuery: LabelQuery): Observable<LabelSearchResponse> => {
    let query: Partial<LabelQuery> = {
        query: labelQuery.query,
    };

    if (labelQuery.customFieldId) {
        query = { ...query, customFieldId: labelQuery.customFieldId };
    }

    const queryString = qs.stringify(query);
    const uri = `${contextPath}/rest/servicedesk/1/customer/portal/${labelQuery.portalId}/requestType/${labelQuery.requestTypeId}/labels/suggest?${queryString}`;

    // Suppressing existing violation. Please fix this.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return get(uri)
        .map((ajaxResponse) => {
            const response = ajaxResponse.response as LabelSearchRawResponse;
            return response.suggestions.map((suggestion) => suggestion.label);
        })
        .catch((e) => {
            trackError('findlabel.fetch.failed', {}, e);
            return Observable.throw(e);
        });
};
